<header class="flex header">
  <h2>
    @if (group) {
      {{ 'UserSetGroups_Title_Update' | translateWF: 'Update Group' }}
    } @else {
      {{ 'UserSetGroups_Title_Add' | translateWF: 'Add Group' }}
    }
    Group
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<div class="content">
  <p-card>
    <div class="col">
      <div class="form-box">
        <label for="">{{ 'UserSetGroups_Name' | translateWF: 'Name' }}</label>
        <input type="text" pInputText [formControl]="name" />
      </div>
      <div class="form-box">
        <label for="">{{ 'UserSetGroups_Description' | translateWF: 'Description' }}</label>
        <input type="text" pInputText [formControl]="description" />
      </div>
      <div class="form-box">
        <label for="groupType">{{ 'UserSetGroups_Type' | translateWF: 'Type' }}</label>
        <p-select
          inputId="groupType"
          [options]="typeOptions"
          optionLabel="fallback"
          optionValue="value"
          [formControl]="type"
          appendTo="body"
          styleClass="cs-fill-width"
          (onChange)="onTypeChange()"
        >
          <ng-template #selectedItem let-option>{{ option.key | translateWF: option.fallback }}</ng-template>
          <ng-template #item let-option>{{ option.key | translateWF: option.fallback }}</ng-template>
        </p-select>
      </div>
      <div class="form-box">
        <div class="flex items-center gap-2">
          <p-checkbox inputId="groupIsDelegable" [binary]="true" [formControl]="isDelegable" />
          <label for="groupIsDelegable">{{ 'UserSetGroups_IsDelegable' | translateWF: 'Visible to external managers' }}</label>
        </div>
        <small>
          {{ 'UserSetGroups_IsDelegable_Hint' | translateWF: 'Delegated user managers can assign this group to their users. Only Standard groups can be visible.' }}
        </small>
      </div>
      <p-divider />
      <div class="form-box">
        <label for="">{{ 'UserSetGroups_Role' | translateWF: 'Role' }}</label>
        <p-multiselect [options]="rolesOfType()" [formControl]="roles" class="w-full" optionLabel="name" display="chip" optionValue="id" appendTo="body" />
        <small>
          @if (isGlobal()) {
            {{ 'UserSetGroups_Roles_Hint_Global' | translateWF: "Showing Global roles only — matches this group's type." }}
          } @else {
            {{ 'UserSetGroups_Roles_Hint_Standard' | translateWF: "Showing Standard roles only — matches this group's type." }}
          }
        </small>
      </div>
    </div>
  </p-card>
</div>
<footer>
  <p-button class="w-full" label="{{ 'UserSetGroups_Save' | translateWF: 'Save' }}" (click)="onSubmit()" />
  <p-button class="w-full" label="{{ 'UserSetGroups_Exit' | translateWF: 'Exit' }}" variant="outlined" (click)="onClose()" />
</footer>
